import { Toaster, resolveValue } from "react-hot-toast";

import { Notification } from "@/features/common/components/Notification";

export const CustomToaster = () => (
  <Toaster>
    {(t) => <Notification t={t}>{resolveValue(t.message, t)}</Notification>}
  </Toaster>
);
